"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DynamicVariantValues = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productItemValueRadios = require("./productItemValueRadios");
var _labelPropTypes = require("../../productTableLabels/defaults/labelPropTypes");
var _productItemValueYesNoBooleanRadios = require("./productItemValueYesNoBooleanRadios");
var _tickCrossIcons = require("./tickCrossIcons");
var _customFormatValue = require("./customFormatValue");
var _tableContext = require("../../productsTable/stateHelpers/tableContext");
var _productHelpers = require("../../../helpers/productHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /* eslint-disable react/forbid-prop-types */
var DynamicVariantValues = exports.DynamicVariantValues = function DynamicVariantValues(_ref) {
  var labelKey = _ref.labelKey,
    labelDefinition = _ref.labelDefinition,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    productDefinition = _ref.productDefinition,
    productGroup = _ref.productGroup,
    _ref$onRadioSelect = _ref.onRadioSelect,
    onRadioSelect = _ref$onRadioSelect === void 0 ? function () {} : _ref$onRadioSelect;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    AllPlans = _useContext$tableCont.AllPlans,
    BaseProducts = _useContext$tableCont.BaseProducts,
    productsAreMerged = _useContext$tableCont.productsAreMerged,
    brandTextElements = _useContext$tableCont.brandTextElements,
    selectedOptions = _useContext.tableState.selectedOptions;
  var label = labelDefinition.label,
    parentField = labelDefinition.parentField,
    valueType = labelDefinition.valueType,
    valueMap = labelDefinition.valueMap,
    formatters = labelDefinition.formatters,
    _labelDefinition$defa = labelDefinition.defaultValueIndex,
    defaultValueIndex = _labelDefinition$defa === void 0 ? 0 : _labelDefinition$defa,
    dynamicVariantValue = labelDefinition.dynamicVariantValue,
    _labelDefinition$hide = labelDefinition.hideGroupLabel,
    hideGroupLabel = _labelDefinition$hide === void 0 ? true : _labelDefinition$hide,
    radioGroupLabel = labelDefinition.radioGroupLabel,
    benefitLimit = labelDefinition.benefitLimit;
  var planNumber = productDefinition.planNumber,
    _productDefinition$is = productDefinition.isVariant,
    isVariant = _productDefinition$is === void 0 ? false : _productDefinition$is,
    basePlanNo = productDefinition.basePlanNo;
  var planGroup = AddOnsMap[isVariant ? basePlanNo : planNumber];
  var basePlan = isVariant ? AllPlans["Plan_".concat(planNumber)] : productDefinition;
  var baseValue = basePlan[dynamicVariantValue];
  var plansWithAddOn = planGroup && Object.values(planGroup).filter(function (variantPlan) {
    return variantPlan.addOns.indexOf(dynamicVariantValue) !== -1;
  });

  // If no plans include this as an add-on just return a tick or cross
  if (!plansWithAddOn || !plansWithAddOn.length) {
    if (typeof baseValue !== 'boolean') {
      return /*#__PURE__*/_react["default"].createElement(_customFormatValue.CustomFormatValue, {
        parentField: parentField,
        productDefinition: productDefinition,
        valueMap: valueMap,
        formatters: formatters
      });
    }
    if (benefitLimit && baseValue) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
        value: baseValue
      }), /*#__PURE__*/_react["default"].createElement("p", null, benefitLimit));
    }
    return /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
      value: baseValue
    });
  }
  var IsChangeableBooleanVariant = function IsChangeableBooleanVariant() {
    var isChangeable = false;
    Object.values(planGroup).forEach(function (variantPlan) {
      var planNumber = variantPlan.planNumber;
      if (AllPlans["Plan_".concat(planNumber)][dynamicVariantValue] !== baseValue) {
        isChangeable = true;
      }
    });
    return isChangeable;
  };
  var getCurrentValue = function getCurrentValue() {
    var activeOptions = selectedOptions.merged ? selectedOptions : (0, _productHelpers.GetInitialPlanOptionsState)({
      BaseProducts: BaseProducts,
      AllPlans: AllPlans,
      brandTextElements: brandTextElements
    });
    if (productsAreMerged) {
      return activeOptions.merged[productGroup][labelKey] || baseValue;
    }
    return activeOptions.allPlans[planNumber] && activeOptions.allPlans[planNumber][labelKey] || baseValue;
  };
  var GetDynamicVariantValues = function GetDynamicVariantValues() {
    /*
      If there is a dynamic relationship the options may be filtered and reduced,
      or increased based on the relationship. For instance, in some products such as CBA,
      the excesses have the same value but different levelOfCover properties. In this
      instance the excess options are reduced, while the levelOfCover options are increased.
     */

    var dynamicOptions = [baseValue].concat(_toConsumableArray(Object.values(planGroup).map(function (variantPlan) {
      return variantPlan[dynamicVariantValue];
    })));
    var uniqValueOptions = _toConsumableArray(new Set(_toConsumableArray(dynamicOptions))).sort();
    return {
      valueOptions: uniqValueOptions.map(function (valueOption) {
        return _defineProperty({}, dynamicVariantValue, valueOption);
      })
    };
  };

  /*
    Check if any of the variants include the property as an add-on
  */
  if (valueType === 'yesNoBoolean') {
    /*
      If the products are all merged, or it is not a variable you can change,
      just show the tick or cross icon with the limit
     */
    if (productsAreMerged && !IsChangeableBooleanVariant()) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Included"), /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
        value: baseValue
      }), /*#__PURE__*/_react["default"].createElement("p", null, benefitLimit));
    }
    if (!productsAreMerged || !IsChangeableBooleanVariant()) {
      return /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
        value: baseValue
      });
    }

    /*
      If the products are displaying in a merged view, or
      it is a variable you can change, show radios
     */
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_productItemValueYesNoBooleanRadios.ProductItemValueYesNoBooleanRadios, {
      planNumber: planNumber,
      disabled: disabled,
      label: label,
      labelKey: labelKey,
      value: getCurrentValue(),
      onRadioSelect: onRadioSelect,
      hideGroupLabel: hideGroupLabel,
      radioGroupLabel: radioGroupLabel
    }), benefitLimit);
  }

  /*
    Check the addOns map to see if the values are
    the same across the other products in the group
  */
  var _GetDynamicVariantVal = GetDynamicVariantValues(),
    valueOptions = _GetDynamicVariantVal.valueOptions;
  if (valueOptions.length > 1) {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueRadios.ProductItemValueRadios, {
      planNumber: planNumber,
      label: label,
      labelKey: labelKey,
      disabled: disabled,
      valueMap: valueMap,
      formatters: formatters,
      defaultValue: getCurrentValue(),
      values: valueOptions,
      defaultValueIndex: defaultValueIndex,
      onRadioSelect: onRadioSelect
    });
  }
  return null;
};
DynamicVariantValues.propTypes = {
  AddOnsMap: _propTypes["default"].any,
  AllPlans: _propTypes["default"].any,
  labelKey: _propTypes["default"].string,
  labelDefinition: _propTypes["default"].shape(_labelPropTypes.LabelPropTypes),
  disabled: _propTypes["default"].bool,
  coverDetails: _propTypes["default"].any,
  productDefinition: _propTypes["default"].any,
  productGroup: _propTypes["default"].string,
  selectedOptions: _propTypes["default"].any,
  onRadioSelect: _propTypes["default"].func,
  productsAreMerged: _propTypes["default"].bool
};
var _default = exports["default"] = {
  DynamicVariantValues: DynamicVariantValues
};